"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse_date_code = exports.fmtIsDate = void 0;
var general_format_utils_1 = require("../general/general-format-utils");
/**
 * 判断是不是日期, 根据是否命中特殊字符进行判断
 * @param foramt 输入 format 格式串
 */
// eslint-disable-next-line complexity, max-lines-per-function
function fmtIsDate(format) {
    var currentChar;
    var index = 0;
    while (index < format.length) {
        switch ((currentChar = format.charAt(index))) {
            case 'G': {
                if (general_format_utils_1.isGeneral(format, index)) {
                    index += 6;
                }
                index += 1;
                break;
            }
            case '"': {
                var isEndQuotation = false;
                while (index + 1 < format.length) {
                    index += 1;
                    if (format.charCodeAt(index) === 34) {
                        isEndQuotation = true;
                        break;
                    }
                }
                // 没有 " 作为结束说明格式串异常, 直接返回
                if (!isEndQuotation) {
                    return false;
                }
                index += 1;
                break;
            }
            case 'B':
            case 'b': {
                if (format.charAt(index + 1) === '1' || format.charAt(index + 1) === '2') {
                    return true;
                }
                index += 1;
                break;
            }
            // 以下均为时间、 日期关键词
            case 'M':
            case 'D':
            case 'Y':
            case 'H':
            case 'S':
            case 'E':
            case 'm':
            case 'd':
            case 'y':
            case 'h':
            case 's':
            case 'e':
            case 'g': {
                return true;
            }
            case 'A':
            case 'a': {
                // 判断接下来三个字符
                var nextString = format.substr(index, 3);
                // 上午下午
                if (nextString.toUpperCase() === 'A/P') {
                    return true;
                }
                // 周几
                if (nextString.toUpperCase() === 'AAA') {
                    return true;
                }
                // 判断接下来四个字符
                nextString = format.substr(index, 4);
                // 星期几
                if (nextString.toUpperCase() === 'AAAA') {
                    return true;
                }
                // 判断接下来五个字符
                nextString = format.substr(index, 5);
                // 上午下午
                if (nextString.toUpperCase() === 'AM/PM') {
                    return true;
                }
                index += 1;
                break;
            }
            case '上': {
                // 上午下午
                if (format.substr(index, 5).toUpperCase() === '上午/下午') {
                    return true;
                }
                index += 1;
                break;
            }
            case '[': {
                var tempString = currentChar;
                while (format.charAt(index) !== ']') {
                    index += 1;
                    if (index >= format.length) {
                        break;
                    }
                    tempString += format.charAt(index);
                }
                // [] 内为时间关键词
                if (tempString.match(/\[[HhMmSs]*\]/)) {
                    return true;
                }
                break;
            }
            case '.':
            case '0':
            case '#': {
                while (index < format.length) {
                    index += 1;
                    currentChar = format.charAt(index);
                    if (('0#?.,E+-%'.indexOf(currentChar) > -1)
                        || (currentChar === '\\'
                            && format.charAt(index + 1) == '-'
                            && '0#'.indexOf(format.charAt(index + 2)) > -1)) {
                        continue;
                    }
                    else {
                        break;
                    }
                }
                break;
            }
            default: {
                index += 1;
                break;
            }
        }
    }
    return false;
}
exports.fmtIsDate = fmtIsDate;
/**
 * 将日期数值解析为具体的年、月、日、时、分、秒
 * TODO: 函数名称向外暴露, 后期修改
 * @param val 输入值
 * @param options 可选参数
 * @param isSpecialStartTime 是否以 1900 年 1 月 为参考点
 */
// eslint-disable-next-line complexity, max-lines-per-function
function parse_date_code(val, options, isSpecialStartTime) {
    // 若类型不为 number 直接返回 null
    if (typeof val !== 'number') {
        return null;
    }
    // 定义相关魔数
    var excelMaxDayLimit = 2958466;
    var minialSubsecond = 1e-6;
    var specialStartTime = {
        default: [1317, 8, 29],
        twoMonth: [1317, 10, 29],
    };
    var normalStartTime = {
        default: [1900, 1, 0],
        twoMonth: [1900, 3, 1],
    };
    // excel 支持的最大时间天数为 2958466
    if (val >= excelMaxDayLimit || val < 0) {
        return null;
    }
    // 取整数部分
    var date = val | 0;
    var time = Math.floor(24 * 3600 * (val - date));
    var week = 0;
    var finalDate = [];
    var output = {
        date: date,
        time: time,
        subsecond: 24 * 3600 * (val - date) - time,
        year: 0,
        month: 0,
        day: 0,
        hour: 0,
        minute: 0,
        second: 0,
        week: 0,
    };
    // 秒以下的时间太小忽略
    if (Math.abs(output.subsecond) < minialSubsecond) {
        output.subsecond = 0;
    }
    // 以1904年作为相对起始时间需要加上4年的天数
    if (options === null || options === void 0 ? void 0 : options.date1904) {
        date += 1462;
    }
    if (output.subsecond >= 0.95) {
        output.subsecond = 0;
        time += 1;
        if (time === 24 * 3600) {
            // 由于加一秒后刚好满一天, 因此进位
            time = 0;
            output.time = 0;
            date += 1;
            output.day += 1;
        }
    }
    if (date === 60) {
        // 对齐 excel, 有 1900/2/29 这一天
        // finalDate = specialStartTime ? [1317, 10, 29] : [1900, 2, 29];
        // 产品决策不对齐了, 因为存在大量历史数据
        // 由导入导出后台进行兼容
        finalDate = isSpecialStartTime ? specialStartTime.twoMonth : normalStartTime.twoMonth;
        week = 4;
    }
    else if (date === 0) {
        finalDate = isSpecialStartTime ? specialStartTime.default : normalStartTime.default;
        week = 6;
    }
    else {
        /**
         * execl 有 1900/2/29(60) 这一天, date 大于 60 时, 算了这一天
         * 在 web 日期系统上不存在这一天, 所以用 web API 计算日期时, date 数值需要减 1
         */
        // const realDate = date > 60 ? date - 1: date;
        // 产品决策不对齐了
        var realDate = date;
        /* 1 = Jan 1 1900 in Gregorian */
        var startDate = new Date(1900, 0, 1);
        startDate.setDate(realDate);
        finalDate = [startDate.getFullYear(), startDate.getMonth() + 1, startDate.getDate()];
        week = startDate.getDay();
        /**
         * excel 1900/2/29 占用的这一天, 也占用了那个星期三
         * 所以这一天之前的星期几, 在 web 日期系统中计算出来, 星期几也要减1天
         */
        if (date < 60) {
            week = (week + 6) % 7;
        }
        if (isSpecialStartTime) {
            week = 0;
        }
    }
    // 年、月、日
    output.year = finalDate[0], output.month = finalDate[1], output.day = finalDate[2];
    // 秒
    output.second = time % 60;
    // 分
    time = Math.floor(time / 60);
    output.minute = time % 60;
    // 时
    time = Math.floor(time / 60);
    output.hour = time;
    // 星期
    output.week = week;
    return output;
}
exports.parse_date_code = parse_date_code;
//# sourceMappingURL=date-format-utils.js.map